import config from '@/config';
import { Auth, createAuth } from '@justgiving/auth';
import { gotoUrl } from './url';
import { RedirectToLoginError } from '@/components/ErrorBoundary/errors';
import { BBAuth } from '@blackbaud-internal/auth-client';
import type { BBAuthGetTokenArgs } from '@blackbaud-internal/auth-client/src/auth/auth-get-token-args';

const previousAuth = createAuth({
  documentOrReq: document,
  authCookieName: config.auth.bearerCookieName,
  activeGroupCookieName: config.auth.activeGroupCookieName,
  refreshAccessTokenUrl: config.auth.refreshAccessTokenUrl,
});

export interface AuthWithHelpers extends Auth {
  isLoggedIn(): boolean;
}

const isLoggedIn = () => previousAuth.isUserLoggedIn();

const newAuth: AuthWithHelpers = {
  ...previousAuth,
  isLoggedIn,
};

export function redirectToSSO(returnUrl: string = window.location.href) {
  gotoUrl(config.loginUrl + encodeURIComponent(returnUrl));
}

export function getCharityGroupTypeExternalId() {
  const activePermission = newAuth.getActivePermission('charity');

  if (!activePermission?.groupTypeExternalId) {
    throw new RedirectToLoginError({
      loginUrl: `${config.charitySSOUrl}${encodeURIComponent(
        window.location.href
      )}`,
    });
  }

  return activePermission.groupTypeExternalId;
}

export async function getBBToken(bbAuthGetTokenArgs?: BBAuthGetTokenArgs) {

  try {
    return await BBAuth.getToken(bbAuthGetTokenArgs);
  } catch {
    throw new RedirectToLoginError({loginUrl: `${config.loginUrl}${encodeURIComponent(window.location.href)}`});
  }
}


export default newAuth;
